package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.navigation.NavHostController
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.resources.stringResource
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.error_employee_number
import com.hyperether.goodjob.resources.error_manager_number
import com.hyperether.goodjob.resources.you_are_offline
import kotlinx.coroutines.flow.StateFlow

@Composable
fun UserRestrictionPopUps(
    isManagerNumberExceeded: StateFlow<Boolean>,
    isEmployeeNumberExceeded: StateFlow<Boolean>,
    navHostController: NavHostController
) {
    Box(
        modifier = Modifier.fillMaxSize().background(Color.Transparent)
    ) {
        if (isManagerNumberExceeded.value) {
            if (getPlatformChecker().isMobile()) {
                ErrorDialog(
                    onDismiss = { navHostController.popBackStack() },
                    title = stringResource(Res.string.error).uppercase(),
                    message = stringResource(Res.string.error_manager_number)
                )
            } else {
                ErrorDialogWeb(
                    onDismiss = { navHostController.popBackStack() },
                    title = stringResource(Res.string.error).uppercase(),
                    message = stringResource(Res.string.error_manager_number)
                )
            }
        }
        if (isEmployeeNumberExceeded.value) {
            if (getPlatformChecker().isMobile()) {
                ErrorDialog(
                    onDismiss = { navHostController.popBackStack() },
                    title = stringResource(Res.string.error).uppercase(),
                    message = stringResource(Res.string.error_employee_number)
                )
            } else {
                ErrorDialogWeb(
                    onDismiss = { navHostController.popBackStack() },
                    title = stringResource(Res.string.error).uppercase(),
                    message = stringResource(Res.string.error_employee_number)
                )
            }
        }
    }
}

@Composable
fun NoInternetPopup(
    navHostController: NavHostController
) {
    Box(
        modifier = Modifier.fillMaxSize().background(Color.Transparent)
    ) {
        if (getPlatformChecker().isMobile()) {
            ErrorDialog(
                onDismiss = { navHostController.popBackStack() },
                title = stringResource(Res.string.error).uppercase(),
                message = stringResource(Res.string.you_are_offline)
            )
        } else {
            ErrorDialogWeb(
                onDismiss = { navHostController.popBackStack() },
                title = stringResource(Res.string.error).uppercase(),
                message = stringResource(Res.string.you_are_offline)
            )
        }
    }
}